import { CustomTable, TableEmptyState } from 'app/components'
import { EsusEnvioListItem } from '../../core/_models'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { esusEnviosColumns } from './columns/_columns'
import { EsusEnvioExpandedRow } from './columns/EsusEnvioExpandedRow'

export const EsusEnvioListTable = () => {
  const { state } = useQueryRequest()
  const { isLoading, isError, refetch, response } = useQueryResponse()
  // Filtro aplicado = algum parâmetro com valor (o header grava `undefined` no que foi limpo).
  const temFiltro = Object.values(state.params ?? {}).some((valor) => valor != null && valor !== '')

  return (
    <CustomTable<EsusEnvioListItem>
      id='kt_table_esus_envios'
      ariaLabel='Envios ao PEC e-SUS APS'
      itemLabel={{ singular: 'envio', plural: 'envios' }}
      data={response?.data || []}
      columns={esusEnviosColumns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={
        temFiltro ? (
          <TableEmptyState
            title='Nenhum envio encontrado'
            description='Revise os filtros aplicados.'
          />
        ) : (
          <TableEmptyState
            title='Nenhum envio ao PEC ainda'
            description='Os envios aparecem aqui conforme os atendimentos e cadastros forem enviados.'
          />
        )
      }
      queryHooks={{ useQueryRequest, useQueryResponse }}
      // Unidade, data do atendimento, tentativas e UUID já vêm na própria linha.
      enableExpand
      onExpandFetch={async (row) => row.original}
      getExpandLabel={(row) => `envio ${row.id}`}
      renderExpand={(data: EsusEnvioListItem, loading) => (
        <EsusEnvioExpandedRow envio={data} isLoading={loading} />
      )}
    />
  )
}
